/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Seat_CountInputs */

const vi_vehicle_seat_count = /** @type {(inputs: Vehicle_Seat_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số chỗ`)
};

/**

* @param {Vehicle_Seat_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_seat_count = /** @type {((inputs?: Vehicle_Seat_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Seat_CountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_seat_count(inputs)
});